import type { CMSConfig } from '#types/config/components/cms'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    title: 'mb-4 lg:mx-9 lg:mb-6',
    carouselContainer: '-mr-4',
    carouselControls: 'bg-white/50 -mt-9',
    carouselCardContent: 'pl-4',
    carouselCard: 'pr-4'
  },
  carouselArrowsSize: 'lg',
  carouselLoop: true,
  spacing: {
    none: 0,
    small: 1,
    medium: 1.5,
    large: 2,
    xlarge: 2.5
  },
} satisfies RecursivePartial<CMSConfig['articleCarousel']>
